import React from "react";
import styled, { useTheme } from "styled-components";
import PropTypes from "prop-types";
import Button from "components/Button";
import Link from "next/link";

const OuterWrapper = styled.section`
  align-items: center;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.themeColors.primary};
  color: ${({ theme, fontColor }) => fontColor || theme.themeColors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 1.5rem;
  text-align: center;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    padding: 3.5rem 1.5rem;
  `}

  ${({ theme }) => theme.mq.lg`
    padding: 6rem 1.5rem 7rem;
  `}
`;

const IconWrapper = styled.div`
  margin: 0 0 1.5rem;
`;

const Title = styled.h3`
  font-size: 2.25rem;
  letter-spacing: -0.066875rem;
  margin: 0 auto 1.5rem;
  width: 100%;

  br {
    display: none;
  }

  ${({ theme }) => theme.mq.md`
    font-size: 2.875rem;
    max-width: 38.75rem;

    br {
      display: block;
    }
  `}

  ${({ theme }) => theme.mq.lg`
    font-size: 3.5rem;
    max-width: 47.5rem;
  `}
`;

const Description = styled.p`
  margin: 0 auto 3rem;
`;

const ButtonWrapper = styled.a`
  display: flex;
  margin: 0 auto;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    max-width: 18.0625rem;
  `}
`;

function IconTextButton({
  backgroundColor,
  fontColor,
  icon: Icon,
  description,
  title,
  buttonLink,
  buttonText,
}) {
  const theme = useTheme();
  return (
    <OuterWrapper
      backgroundColor={theme.themeColors[backgroundColor]}
      fontColor={theme.themeColors[fontColor]}
    >
      <IconWrapper>
        <Icon color={theme.themeColors[fontColor]} width={70} height={40} />
      </IconWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Link href={buttonLink} passHref>
        <ButtonWrapper>
          <Button colorType={fontColor} outlineType="outline">
            {buttonText}
          </Button>
        </ButtonWrapper>
      </Link>
    </OuterWrapper>
  );
}

export default IconTextButton;

IconTextButton.propTypes = {
  backgroundColor: PropTypes.string,
  fontColor: PropTypes.string,
  icon: PropTypes.func,
  description: PropTypes.shape({}),
  title: PropTypes.shape({}),
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
};

IconTextButton.defaultProps = {
  backgroundColor: "",
  description: {},
  fontColor: "",
  icon: undefined,
  title: {},
  buttonText: "Join GoodFriend",
  buttonLink: "/search",
};
